import request from "@/utils/request";
import Cookies from "js-cookie";
import i18n from '@/locales/i18n';

const domain = i18n.global.locale.value == "en" ? ".sialchina.com" : ".sialchina.cn";

const state = {
  isLogin: Cookies.get("visitor_token") ? true : false,
  truename: Cookies.get("truename"),
  roles: [],
  is_need_completion_certificates: false, // 是否弹出提示补全身份证
  is_need_completion_survey: false, //是否弹出提示提交问卷
  expo_list: [], //展会信息
  show_special_menu: true, // 是否显示特殊菜单
  precise_match_booth_open: 0,
  precise_match_buyer_open: 0,
};
const mutations = {
  SET_STATUS: (state, data) => {
    state.isLogin = data;
  },
  SET_TRUENAME: (state, data) => {
    state.truename = data;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
    console.log("state.roles", state.roles)
  },
  SET_NEED_CERTIFICATES: (state, data) => {
    state.is_need_completion_certificates = data;
  },
  SET_NEED_survey: (state, data) => {
    state.is_need_completion_survey = data;
  },
  SET_EXPO_LIST: (state, data) => {
    state.expo_list = data;
  },
  SET_SHOW_SPECIAL_MENU: (state, data) => {
    state.show_special_menu = data;
  },
  SET_PRECISE_MATCH_BOOTH_OPEN: (state, data) => {
    state.precise_match_booth_open = data;
  },
  SET_PRECISE_MATCH_BUYER_OPEN: (state, data) => {
    state.precise_match_buyer_open = data;
  },
};

const domainUri = i18n.global.locale.value == "en" ? ".sialchina.com" : ".sialchina.cn";

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { app_lang } = userInfo;
    return new Promise((resolve, reject) => {
      request({
        url: "/visitor/login",
        method: "post",
        data: userInfo,
      })
        .then((response) => {
          const { data } = response;
          // 存放令牌状态
          if (data['visitor-token']) {
            console.log("store-登录-then", domainUri);
            
            commit("SET_STATUS", true);
            Cookies.set('visitor_token', data['visitor-token'], { expires: 1 })
            Cookies.set('visitor_token', data['visitor-token'], { domain: domainUri, expires: 1 })
            commit("SET_TRUENAME", data.truename);
            Cookies.set("truename", data.truename, { expires: 1 });
          }

          resolve(response);
        })
        .catch((error) => {
          console.log("store-登录-catch", error);
          reject(error);
        });
    });
  },

  // 获取角色
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      request({
        url: "/visitor/getExpoAreaStatus",
        method: "GET",
        params: ""
      })
        .then((response) => {
          const { data } = response;

          const { expo_list = [] } = data;
          let old = expo_list.filter((item) => {
            return item.expo_area_id == 2 && item.is_current == 0;
          });

          var roles = [];
          if (data?.is_current === 1) {
            roles.push("visitor");
          }
          // if (data.visitor_type == 0) {
          //   roles.push("ordinary");
          // } else if (data.visitor_type == 5) {
          //   roles.push("vip");
          // } else {
          //   roles.push("visitor");
          // }

          if (old.length) {
            roles.push("old");
          }

          commit("SET_ROLES", roles);
          commit("SET_NEED_CERTIFICATES", data.is_need_completion_certificates);
          commit("SET_NEED_survey", data.is_need_completion_survey);
          commit("SET_EXPO_LIST", data.expo_list);

          commit("SET_PRECISE_MATCH_BOOTH_OPEN", data.precise_match_booth_open);
          commit("SET_PRECISE_MATCH_BUYER_OPEN", data.precise_match_buyer_open);
          if (data.precise_match_booth_open == 1 || data.precise_match_buyer_open == 1) {
            commit("SET_SHOW_SPECIAL_MENU", true);
          } else {
            commit("SET_SHOW_SPECIAL_MENU", false);
          }
          
          resolve(roles);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 更改角色
  async changeRoles({ commit, dispatch }, role) {
    // 重新获取用户角色
    const roles = (await dispatch("getInfo")) || [];
    console.log("-changeRoles--", roles);

    // 重置路由为初始状态
    dispatch("permission/resetRoutes", null, { root: true });

    // 根据角色生成可访问路由映射
    const accessRoutes = await dispatch("permission/generateRoutes", roles, {
      root: true,
    });
    // 动态添加可访问路由
    dispatch("permission/addRoutes", accessRoutes, {
      root: true,
    });
  },

  // 退出登录
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      request({
        url: "/visitor/logout",
        method: "post",
        data: "",
      })
        .then(() => {
          // 清除令牌状态
          commit("SET_STATUS", false);
          commit("SET_ROLES", []);
          commit("SET_TRUENAME", null);
          Cookies.remove("visitor_token");
          Cookies.remove("visitor_token", {domain: domainUri});
          // Cookies.remove("token", {domain});
          Cookies.remove("truename");
          // Cookies.remove("truename", {domain});
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
